import React from 'react';
import { useNavigate } from 'react-router-dom';
import './PricingSection.css';

const pricingPlans = [
  {
    name: 'Starter',
    price: '₹5,000',
    features: [
      'Basic website (1-3 pages)',
      'Responsive design',
      'Basic contact form',
      'Social media integration',
      '1 revision',
      'Email support for 1 month',
    ],
    cta: 'Get Started',
  },
  {
    name: 'Standard',
    price: '₹15,000',
    features: [
      'Up to 10 pages',
      'Custom design and layout',
      'Basic SEO optimization',
      'Google Analytics setup',
      'Contact form with basic CRM integration',
      '1 month of maintenance',
      '3 revisions',
    ],
    cta: 'Get Started',
  },
  {
    name: 'Premium',
    price: '₹25,000',
    features: [
      'Unlimited pages',
      'Advanced SEO (on-page and off-page)',
      'E-commerce functionality (up to 50 products)',
      'Custom content management system (CMS)',
      'Security features (SSL, firewalls, etc.)',
      '1 month of website maintenance',
      'Unlimited revisions',
      'Dedicated support',
    ],
    cta: 'Get Started',
  },
];

const Pricing: React.FC = () => {
  const navigate = useNavigate();
  return (
    <section className="pricing-cn-section">
      <div className="pricing-badge">Website Pricing &amp; Packages</div>
      <h2 className="pricing-title gradient-text">Affordable Website Development Plans</h2>
      <div className="pricing-lead">
        Get professional web design, SEO, and branding at competitive prices. Our packages are designed for businesses of all sizes, ensuring high-quality digital solutions within your budget. Explore our pricing for custom websites, SEO services, and eCommerce development.
      </div>
      <div className="pricing-grid">
        {pricingPlans.map((plan, i) => (
          <div className="pricing-card" key={plan.name}>
            <div className="plan-name">{plan.name}</div>
            <div className="plan-price">{plan.price}</div>
            <ul className="plan-features">
              {plan.features.map((f, ix) => (
                <li key={ix}><span className="plan-feature-icon">✔️</span> {f}</li>
              ))}
            </ul>
            <button className="plan-cta-btn" onClick={() => navigate('/contact')}>{plan.cta} →</button>
          </div>
        ))}
      </div>
    </section>
  );
};
export default Pricing;
